import { token } from '@atlas-frontend/design-tokens';
import { Tooltip } from '../../common/components/Tooltip';
import { PropsWithChildren } from 'react';
import * as React from 'react';
import { TextBadge } from '../../common/components/TextBadge';
import { AlgorithmAlternative } from '../alternatives/types';
import { useDataObjectFormLabelTranslation } from '../useDataObjectFormLabelTranslation';

export interface AlgorithmAlternativeCellProps {
  alternativeSet?: AlgorithmAlternative;
}

export function AlgorithmAlternativeTooltip({
  alternativeSet,
  children,
}: PropsWithChildren<AlgorithmAlternativeCellProps>) {
  const { t: tLabel } = useDataObjectFormLabelTranslation();

  if (!alternativeSet) {
    return null;
  }

  return (
    <Tooltip
      title={
        `${alternativeSet.code} - ${alternativeSet.name}` +
        (alternativeSet.defaultAlgorithm
          ? ' ' + tLabel('algorithms.alternative.default')
          : '')
      }
      placement="left"
    >
      {children}
    </Tooltip>
  );
}

export function AlgorithmAlternativeCell({
  alternativeSet,
}: AlgorithmAlternativeCellProps) {
  if (!alternativeSet) {
    return null;
  }

  return (
    <AlgorithmAlternativeTooltip alternativeSet={alternativeSet}>
      <span>
        {alternativeSet.defaultAlgorithm ? (
          <TextBadge color={token.colorTextLabel}>
            {alternativeSet.code}
          </TextBadge>
        ) : (
          alternativeSet.code
        )}
      </span>
    </AlgorithmAlternativeTooltip>
  );
}
